import React from 'react';
import UserSummary from "./UserSummary";
import { RecentlyPlayed } from "../../modules/dashboard/recently-played/RecentlyPlayed";
import { PlayingTime } from '../../modules/dashboard/playing-time/PlayingTime';
import { NotesPlayed } from '../../modules/dashboard/notes-played/NotesPlayed';
import { BootcampProgress } from '../../modules/dashboard/bootcamp-progress-section/BootcampProgress';
import { SongsProgress } from '../../modules/dashboard/songs-progress-section/SongsProgress';

export default function DashboardContent() {
  return (
    <div className={`dashboard-content`}>
      <UserSummary />
      <RecentlyPlayed />
      <PlayingTime />
      <NotesPlayed />
      <BootcampProgress />
      <SongsProgress />
    </div>
  );
}
